import Routes from './Routes';
import './App.scss';

export default function App() {
  return <Routes />;
}
